import Vue from 'vue'
import Vuex from 'vuex'
import relation from './modules/relation'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        relation
    }
})
